// js_product_single_sizes_slider

(function () {

	const product_single_sizes_slider_list = document.querySelectorAll('.js_product_single_sizes_slider')

	if (product_single_sizes_slider_list.length) {
		for (let i = 0; i < product_single_sizes_slider_list.length; i++) {
			const slider = product_single_sizes_slider_list[i]
			initTeaserCardSlider(slider)
		}
	}

	function initTeaserCardSlider(slider) {
		const sliderWrapEl = slider.closest('.product_single_sizes_slider-sec')
		const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
		const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
		const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

		const numberOfSlides = sliderWrapEl.querySelectorAll('.sizes-item').length
		const centeredSlides_1200 = numberOfSlides > 3
		const centeredSlides_767 = numberOfSlides > 2

		// Add number of slides class to slider wrapper
		let slides_num_class = 'num_slides'

		if (numberOfSlides === 2) {
			slides_num_class = 'num_slides_2'
		} else if (numberOfSlides === 1) {
			slides_num_class = 'num_slides_1'
		}

		sliderWrapEl.classList.add(slides_num_class)

		let sliderOptions = {

			spaceBetween: 0,
			slidesPerView: 2,
			centeredSlides: false,
			loop: false,
			// Responsive breakpoints
			breakpoints: {
				// when window width is >= 768px
				767: {
					slidesPerView: 2,
					spaceBetween: 0,
					centeredSlides: centeredSlides_767,
				},
				// when window width is >= 1200px
				1200: {
					slidesPerView: 3,
					spaceBetween: 0,
					centeredSlides: centeredSlides_1200,
				}
			},
			pagination: {
				el: swiperPagination,
				clickable: true,
				dynamicBullets: false,
			},
			navigation: {
				nextEl: swiperButtonNext,
				prevEl: swiperButtonPrev,
			},
		}

		new Swiper(slider, sliderOptions)
	}

})()

const sizeBuyNowBtnList = document.querySelectorAll('.js_product_size_buy_now_btn')

if (sizeBuyNowBtnList.length) {
	for (var i = 0; i < sizeBuyNowBtnList.length; i++) {
		const element = sizeBuyNowBtnList[i]
		element.addEventListener('click', handleSizeBuyNowBtnClick)
	}
}

function handleSizeBuyNowBtnClick(e) {
	const btn = e.target
	const parent = btn.parentElement
	const content = parent.querySelector('.js_product_size_buy_now_content').innerHTML
	const modalContent = document.getElementById('product_size_buy_now_modal_content')
	modalContent.innerHTML = content

	const modalEl = document.getElementById('product_size_buy_now_modal')
	const modal = new bootstrap.Modal(modalEl) // initialized with defaults
	modal.show()

}


